"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_AGENTS = exports.FEATURE_FLAGS = void 0;
// User agent strings for product api
const USER_AGENTS = exports.USER_AGENTS = {
  SWP: 'GoDaddy.FOS.SWP',
  QE: 'GoDaddy.FOS.QE'
};
const FEATURE_FLAGS = exports.FEATURE_FLAGS = {
  HIDE_BACK_BUTTON: 'hideBackButton',
  HIDE_PAGE_ELEMENTS: 'hidePageElements',
  SKIP_BASKET: 'skipBasket',
  USE_NEW_TERM_SELECTOR: 'useNewTermSelector'
};